import { convertPlusToSpace, toLowerCaseFirst } from "./utils";

export default class SearchParams {
    constructor() {
        this.objectParameters = this.getObjectFromUrl();
    }

    getObjectFromUrl() {
        const parameters = klevu.getAllUrlParameters();
        const objectParameters = {};
        for (const { name, value } of parameters) {
            if (name) {
				objectParameters[toLowerCaseFirst(name)] = encodeURIComponent(value);
			}
        }
        return objectParameters;
    }

    delete(name) {
        delete this.objectParameters[name];
        return this;
    }

    set(name, value) {
        this.objectParameters[toLowerCaseFirst(name)] = encodeURIComponent(value);
        return this;
    }

	get(name) {
        return decodeURIComponent(this.objectParameters[toLowerCaseFirst(name)] || "");
    }

    has(name) {
        return !klevu.isUndefined(this.objectParameters[toLowerCaseFirst(name)]);
    }

    toString() {
        return klevu.queryString(this.objectParameters);
    }

    forEach(callBack) {
        for (const property in this.objectParameters) {
            callBack(decodeURIComponent(this.objectParameters[property]), property);
        }
        return this;
    }

    paginate(page) {
        if (page == 1) {
            this.delete("page");
        } else {
            this.set("page", page);
        }

        return this;
    }

    pushState() {
		const path = this.toString();
        const newRelativePathQuery = `${window.location.pathname}${path ? '?' + this.toString() : ''}`;
        history.pushState(null, '', convertPlusToSpace(newRelativePathQuery));
        return this;
    }
}



// WEBPACK FOOTER //
// ./klevu/SearchParams.js